module.exports = __webpack_public_path__ + "img/pencil-btn.b16323f4.svg";